<!--
 * @Author: leoqyli leoqyli@tencent.com
 * @Date: 2022-04-11 10:00:04
 * @LastEditors: leoqyli leoqyli@tencent.com
 * @LastEditTime: 2022-07-21 18:27:51
 * @FilePath: /qidian-stellaris/src/page/contact-selector-pro/pc/js/app.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="page-body reset-body-style">
        <contact-selector
            v-if="ready"
            ref="contactSelector"
            :allow-submit-null="allowSubmitNull == 1"
            :cancel-button="cancelButton"
            :config="config"
            :confirm-button="confirmButton"
            :debug="debug === true"
            :display-unit="displayUnit"
            :exclude="exclude"
            :fetch-datasource="getDatasource"
            :fetch-datasource-by-group-id="getDatasourceByGroupId"
            :fetch-detail="getDetail"
            :fetch-search-result="getSearchResult"
            :kind="kind"
            :max-length="maxLength"
            :max-length-weak-warning="!!maxLengthWeakWarning"
            :name-tails="!!uinTails"
            :pre-datasource-map="preDatasourceMap"
            :result-config="resultConfig"
            :result-type="resultType"
            :selected-disable="!!selectedDisable"
            :selector-config="selectorConfig"
            :source-type-config="sourceTypeConfig"
            :show-error-message-tips="showErrorMessageTips"
            :tabs="tabs"
            :value="value"
            :multiple="multiple"
            :warning-tips="warningTips"
            :select-all-mode="selectAllMode"
            :show-action-bar="showActionBar"
            :select-change-sys-to-pc="selectChangeSysToPc"
            :disabled="disabled"
            :get-path="getPath"
            @contact-selector-confirm="onConfirm"
            @contact-selector-cancel="onCancel"
            @error="toast"
        />
    </div>
</template>

<script>
import ContactSelector from '@/components/contact-selector/pc/index.vue';
import mixin from '../../js/mixin';

export default {
    name: 'QDConcatSelector',

    components: {
        ContactSelector
    },

    mixins: [mixin],

    methods: {
        onCancel () {
            if (window.CONTACT_SELECTOR_EXPORT_TYPE === 'component') {
                this.$emit('selector-cancel', {});
            } else {
                window.qdp.pushContactSelectorResult({
                    selected: {
                        cancel: true
                    },
                    fail: res => {
                        this.$message.error(res.errMsg || '提交数据失败');
                    }
                });
            }
        },
        toast(message){
            this.$message.error(message);
        }
    },

    created() {
        window.qdp.invoke && window.qdp.invoke('ui', 'webviewCanScroll', { enable: false });
    }
};
</script>

<style lang="less">
@import '~@/common/contact-selector/_variable';
</style>
